var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{on:{"submit":_vm.onSubmit}},[_c('Subject'),_c('TextEditor',{staticClass:"mt-1"}),_c('Upload',{staticClass:"mt-1"}),_c('Submit',{staticClass:"mt-1"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }